<div class="dialog-content">
  <section>
    <form class="k-form" [formGroup]="annualVacationQuotaHistoryForm">
      <div class="k-d-flex">
        <kendo-formfield>
          <kendo-numerictextbox
            [decimals]="0"
            [format]="'d'"
            [spinners]="false"
            (valueChange)="inputValueChanged($event)"
            id="input-value-changed"
            formControlName="amount"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>

      <div class="k-d-flex">
        <kendo-formfield>
          <kendo-numerictextbox
            [decimals]="0"
            [format]="'d'"
            [spinners]="false"
            (valueChange)="entryIndexChanged($event)"
            id="new-billable-rate"
            formControlName="entryIndex"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>
    </form>
  </section>
</div>

<footer #dialogFooter class="k-d-flex k-justify-content-between">
  <button (click)="close()" kendoButton size="large" themeColor="secondary" class="k-mr-4 !k-pr-4">
    <span class="custom-symbol close k-mr-3"></span>
    <span class="label">Schließen</span>
  </button>

  <button
    kendoButton
    (click)="submit()"
    class="!k-pr-4"
    themeColor="base"
    size="large"
    [disabled]="!updateEnabled"
  >
    <fa-icon class="add k-text-white k-mr-3" [icon]="faPenToSquare"></fa-icon>
    <span class="label">Ändern</span>
  </button>
</footer>
